export const removeIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><path fill="none" stroke="currentColor" stroke-width="1.3" d="m1 9 8-8m0 8L1 1"/></svg>`,
    name: 'remove' as const
};